import { render, staticRenderFns } from "./VendorOnboarding.vue?vue&type=template&id=873ac7f0&"
import script from "./VendorOnboarding.vue?vue&type=script&lang=js&"
export * from "./VendorOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports